export default __webpack_public_path__ + "static/media/calendar-icon.cf215a60.svg";